import { ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { PageviewsettingsService } from '../services/pageviewsettings.service';
import { TenantService } from '../services/tenant.service';
import * as Globals from '../../globals';

declare let analytics: any;

@Component({
	selector: 'app-why',
	templateUrl: './why.component.html',
	styleUrls: ['./why.component.css']
})

export class WhyComponent {
	facultyEnabled: boolean = false; // True after the user visits the Faculty Page via direct URL which will set the local storage key: facultyEnabled.
	tenantId: any;
	affiliateId: any;
	loadeddata: any;
	logoPrimaryImageUrl = '';
	logoSecondaryImageUrl = '';
	tenantName: string = window.location.href.split('/')[3]; // TODO: Find a better way to do this.
	bgImageUrl = '';
	tenant: TenantService;

	constructor(
			private router: Router,
			private route: ActivatedRoute,
			private settingsService: PageviewsettingsService,
			private cdr: ChangeDetectorRef,
			private tenantService: TenantService) {
		this.tenant = tenantService;
		this.facultyEnabled = this.tenant.getFacultyVisibility();

        this.router.events.pipe(filter((event: any) => event instanceof NavigationEnd)).subscribe(() => {
			const flag = this.tenant.getFacultyVisibility();
			if (flag !== this.facultyEnabled) {
				this.facultyEnabled = flag;
				this.cdr.detectChanges();
			}
		});

		let collegeName = this.route.snapshot.paramMap.get('collegemobile') || '/defaultpage';

		this.settingsService.getCollegetenantcode(collegeName).subscribe((data: { result: { id: string; affiliateId: any; }; }) => {
			this.tenantId = parseInt(data.result.id)
			this.affiliateId = data.result.affiliateId
	
			this.loadPageSettings()
		});
    }

	loadPageSettings() {
		// const affiliateId = 1;  
		// const tenantId = 1;
		// const pageName = 'landingpage';
		this.settingsService.getPageViewSettings(this.affiliateId,this.tenantId).subscribe(data => {
			this.loadeddata = data.result; 
			// console.log(this.loadeddata)
			// this.updateContent()
			console.log('Response from API', this.loadeddata);
		});
    }

	trackevent(event:any) {
		analytics.track(event)
	}
}
